import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
class ClientService {
  static GetDetailClient(clientId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/client/detailclient/${clientId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);

        if (ok) return;
        throw error;
      });
  }

  static GetClient(clientId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/client/client/${clientId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        throw error;
      });
  }

  static ArchiveClient(clientId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/client/archive/${clientId}`, {}, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "archive");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        throw error;
      });
  }

  static UnarchiveClient(clientId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/client/unarchive/${clientId}`, {}, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "unarchive");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        throw error;
      });
  }

  static DeleteClient(clientId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/client/delete/${clientId}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        throw error;
      });
  }

  static GetClients() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    return axios
      .get(`${envConfig.apiBaseUrl}/api/client/clients`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
      });
  }

  static QuickCreate(client) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    if (client.defaultImageId === "") {
      client.defaultImageId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/client/quickcreate`, client, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        return ServiceHelper.IsEmptyGuid(response.data.data) ? null : response.data.data;
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static AddNote(note) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/client/addNote`, note, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "create");
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static DeleteNote(externalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/client/deleteNote/${externalId}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return true;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }

  static UpdateNote(externalId, editNote) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    editNote.externalId = externalId;

    return axios
      .post(`${envConfig.apiBaseUrl}/api/client/editNote`, editNote, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "update");
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static AddMedia(fileId, externalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    let postUrl = "";
    let obj = null;
    if (Array.isArray(fileId)) {
      postUrl = `${envConfig.apiBaseUrl}/api/client/addMedias`;
      obj = { fileIds: fileId, externalId };
    } else {
      postUrl = `${envConfig.apiBaseUrl}/api/client/addMedia`;
      obj = { fileId, externalId };
    }

    return axios
      .post(postUrl, obj, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "create");
      })
      .catch((error) => {
        ServiceHelper.ApiCallPostCatchValidation(error);
        return false;
      });
  }

  static Update(client) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
    if (client.defaultImageId === "") {
      client.defaultImageId = null;
    }

    return axios
      .post(`${envConfig.apiBaseUrl}/api/client/update`, client, config)
      .then((response) => {
        return ServiceHelper.ApiCallPostValidation(response, "update");
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return;
      });
  }
}

export default ClientService;
